import { Button } from "@tblabs/truffle";
import { XButton } from "./XButton";


export class XWarningButton extends XButton
{
    constructor(text: string, icon: string, onClick: (btn: Button) => void)
    {
        super("warning", text, icon, onClick);
    }
}
